/**************************************************************************************************
 *
 *       Footer at bottom of all pre-login views
 *
 *       Contains:
 *           -   2 links:
 *               -   Privacy Policy
 *               -   Contact Support
 *           -   Change language button/link
 *
 */

/********************************************* ASSETS *********************************************/
const s = require('./auth-landing-footer.scss');

/******************************************** IMPORTS *********************************************/
import React from 'react';
import cn from 'classnames';
import {inject} from 'mobx-react';

/**************************************** PROJECT IMPORTS *****************************************/
import {ConfigProps, translate, CILink} from '@canimmunize/core-imports';
import {ChangeLanguageButtonContainer} from './change-language-button/change-language-button-container';

/********************************************* EXPORT *********************************************/
/**
 * Footer at bottom of all pre-login view
 * Contains privacy policy, contact support, and change language links
 */
export const AuthLandingFooter = inject('config')((props?: ConfigProps) => {
    return (
        <footer role="contentinfo" className={cn(s[`footer`])}>
            <CILink
                id={props.config.elementIds.auth.footer.privacyPolicyLink}
                to={props.config.urls.canimmunizeWeb.privacyPolicy}
                promptIfUnsaved={false}
                className={cn(s[`footer-link`], `mr-2p`)}
            >
                {translate(`privacy_policy`)}
            </CILink>
            <CILink
                id={props.config.elementIds.auth.footer.contactSupportLink}
                to={props.config.urls.canimmunizeWeb.contactSupport}
                promptIfUnsaved={false}
                className={cn(s[`footer-link`], `mr-2p ml-2p`)}
            >
                {translate(`contact_support_short`)}
            </CILink>
            <ChangeLanguageButtonContainer />
        </footer>
    );
});

AuthLandingFooter.displayName = `AuthLandingFooter`;
